<template>
  <md-card md-with-hover v-if="value">
    <md-card-header>
      <md-field v-if="value.is_new">
        <label>Strategy type</label>
        <md-select v-model="value.type">
          <template v-for="rule in ruleTypes">
            <md-option :key="'rule_' + rule" :value="rule">{{
                mapRuleLabel(rule)
            }}</md-option>
          </template>
        </md-select>
      </md-field>
      <h4 v-else>{{ mapRuleLabel(value.type) }}</h4>
    </md-card-header>
    <md-card-content>
      <keep-alive>
        <component
          v-if="!value.is_new || value.is_ready"
          v-bind:is="value.type"
          v-model="value"
        ></component>
      </keep-alive>
    </md-card-content>
    <md-card-actions v-if="!value.is_new">
      <md-button
        v-if="withMoveUp"
        class="md-icon-button md-white"
        @click="$emit('moveUp')"
      >
        <md-icon>arrow_drop_up</md-icon>
      </md-button>
      <md-button
        v-if="withMoveDown"
        class="md-icon-button md-white"
        @click="$emit('moveDown')"
      >
        <md-icon>arrow_drop_down</md-icon>
      </md-button>
      <md-button class="md-icon-button md-white" @click="remove">
        <md-icon>delete</md-icon>
      </md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import Vue from "vue";
import PricingRuleMixins from "./PricingRuleMixins";

export default {
  name: "PricingRule",
  mixins: [PricingRuleMixins],
  props: {
    value: Object,
    withMoveDown: Boolean,
    withMoveUp: Boolean
  },
  computed: {
    ruleTypes() {
      return Object.keys(this.$options.components)
        .filter(type => type != "PricingRule")
        .filter(type => type != "CompsetPricingStrategy")
        .map(type => {
          return type;
        });
    }
  },
  methods: {
    remove() {
      if (confirm("Are you sure?")) {
        Vue.set(this.value, "deleted", true);
      }
    },
    moveUp: () => {
      alert("Move position UP");
    },
    moveDown: () => {
      alert("Move position DOWN");
    }
  },
  created() {
    const requireComponent = require.context(
      // The relative path of the components folder
      "./PricingStrategies",
      // Whether or not to look in subfolders
      false,
      // The regular expression used to match base component filenames
      /[A-Z]\w+PricingStrategy\.(vue|js)$/
    );

    requireComponent.keys().forEach(fileName => {
      const componentConfig = requireComponent(fileName);
      // Gets the file name regardless of folder depth
      const componentName = fileName
        .split("/")
        .pop()
        .split(".")[0];
      // register the component locally
      const componentConfigDefault = componentConfig.default;
      this.$options.components[componentName] = componentConfigDefault;
    });
  },
  watch: {
    "value.type": function(type) {
      if (this.value.is_new) {
        this.initNewRule(this.value);
      }
    }
  }
};
</script>

<style lang="scss">
.pricing-rule {
  display: flex;
  align-items: center;
  margin-top: 13px;
}
.pricing-rule:first-of-type {
  margin-top: 0;
}
.pricing-rule > * {
  margin-right: 15px;
}
</style>
